import { api } from 'src/api';
import { types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const getSettingsByBillIdAsync = createAsync(body => {
  return async function getSettingsByBillId(options) {
    const resp = await api.AppfolioBills.getSettingsByBillId(body, options);
    return resp;
  };
});
const getSettingsByBillIdV2Async = createAsync(body => {
  return async function getSettingsByBillIdV2(options) {
    const resp = await api.AppfolioBills.getSettingsByBillIdV2(body, options);
    return resp;
  };
});
const postBillSettingsAsync = createAsync(body => {
  return async function postBillSettings(options) {
    const resp = await api.AppfolioBills.postBillSettings(body, options);
    return resp;
  };
});
const AppfolioBillsApiStore = types.model('AppfolioBillsApiStore', {
  getSettingsByBillIdAsync,
  getSettingsByBillIdV2Async,
  postBillSettingsAsync
});
export const appfolioBillsApi = types.optional(AppfolioBillsApiStore, {});